export const isStaging =
  process.env.NEXT_PUBLIC_ENV === "staging" ||
  process.env.NODE_ENV === "development";
